import React, { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";

import { useCreateSimplyAcincoContext } from "../provider/createSimplyAcinco.provider";
import PrimaryButton from "../../../../../components/buttons/PrimaryButton";

const StatusPaymentComponent = () => {
  const { infoPayment, formData, handleInitialState } =
    useCreateSimplyAcincoContext();
  const modalRef = useRef<HTMLDivElement>(null);

  // MODO DEMO: Simular estados de pago
  const [demoStatus, setDemoStatus] = useState<"pending" | "paid" | "insured">(
    "pending",
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simular verificación de pago (30 segundos)
    const timer = setTimeout(() => {
      setDemoStatus("insured");
      setIsLoading(false);
    }, 30000); // 30 segundos

    return () => clearTimeout(timer);
  }, []);

  // Datos demo para mostrar cuando el pago esté "asegurado"
  const demoData = {
    data: {
      status: demoStatus,
      policyId: `DEMO-${formData?.imei || "123456789012345"}`,
      transactionId: `TRX-${Date.now()}`,
    },
  };

  const data = demoData;

  /* CÓDIGO REAL - Comentado para demo
  const { data, isLoading } = useGetStatusPurchaseAgent(
    infoPayment?.checkout?.sessionTransaction,
    {
      refetchInterval: 30000,
    },
  );
  */

  const clearProcess = async () => {
    handleInitialState();
  };

  const handleWindowOpen = () => {
    window.open(infoPayment?.checkout?.plan?.checkoutUrl || "", "_blank");
  };

  return (
    <section>
      {(data?.data?.status === "pending" ||
        isLoading ||
        data?.data?.status === "paid") && (
        <div className="rounded-2xl bg-white p-4" ref={modalRef}>
          <h2 className="mb-3 text-center text-4xl font-semibold">
            Completa tu pago
          </h2>
          <p className="text-xl font-normal">
            Para continuar, realiza el pago de tu póliza escaneando el código QR
            o haciendo clic en el botón. Una vez completado el pago, la
            verificación puede tardar unos minutos. Por favor, espera mientras
            confirmamos tu transacción.
          </p>
          <div className={`flex w-full flex-col items-center justify-center`}>
            <QRCode
              value={infoPayment?.checkout?.plan?.checkoutUrl || ""}
              className="my-5 hidden h-40 w-40 md:block"
            />
            <PrimaryButton
              title="Pagar ahora"
              onClick={handleWindowOpen}
              className="rounded-2xl bg-buttonBlack px-5 text-white"
            />
          </div>
          <dl className="flex flex-col items-center justify-center space-y-4">
            <p className="text-lg font-semibold">
              Estamos verificando su pago, por favor espere.
            </p>
            <div className="mt-2 flex items-center justify-center space-x-2">
              <div className="h-4 w-4 animate-bounce rounded-full bg-blueFinance [animation-delay:-0.3s]"></div>
              <div className="h-4 w-4 animate-bounce rounded-full bg-blueFinance [animation-delay:-0.15s]"></div>
              <div className="h-4 w-4 animate-bounce rounded-full bg-blueFinance"></div>
            </div>
          </dl>
        </div>
      )}
      {data?.data?.status === "insured" && (
        <div className="rounded-2xl bg-white p-4" ref={modalRef}>
          <div className="flex flex-col items-center justify-center space-y-4">
            <h2 className="mb-3 text-center text-4xl font-semibold">
              Pago verificado
            </h2>
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 100 100"
              xmlSpace="preserve"
              className="h-24 w-24"
            >
              <circle
                className="path circle"
                fill="none"
                stroke="#73AF55"
                strokeWidth="6"
                strokeMiterlimit="10"
                cx="50"
                cy="50"
                r="48"
              />
              <polyline
                className="path check"
                fill="none"
                stroke="#73AF55"
                strokeWidth="6"
                strokeLinecap="round"
                strokeMiterlimit="10"
                points="70.2,27.5 41.9,74.4 29.8,62.3 "
              />
            </svg>
            <p className="text-lg font-semibold">
              Su pago ha sido verificado exitosamente y su póliza está activa.
            </p>
          </div>
          <div className="mt-10 rounded-2xl border-2 border-gray bg-white p-4 shadow-sm">
            <h2 className="mb-3 text-lg font-semibold">Datos de la póliza</h2>
            <dl className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
              <div>
                <dt className="text-gray-500 text-sm">Nombre</dt>
                <dd className="font-medium">{formData?.name}</dd>
              </div>
              <div>
                <dt className="text-gray-500 text-sm">Email</dt>
                <dd className="font-medium">{formData?.email}</dd>
              </div>
              <div>
                <dt className="text-gray-500 text-sm">Tipo de documento</dt>
                <dd className="font-medium">{formData?.typeDocument}</dd>
              </div>
              <div>
                <dt className="text-gray-500 text-sm">Número de documento</dt>
                <dd className="font-medium">{formData?.numberDocument}</dd>
              </div>
              <div>
                <dt className="text-gray-500 text-sm">Póliza</dt>
                <dd className="font-medium">{data?.data?.policyId}</dd>
              </div>
              <div>
                <dt className="text-gray-500 text-sm">Número de transacción</dt>
                <dd className="font-medium">{data?.data?.transactionId}</dd>
              </div>
              <div>
                <dt className="text-gray-500 text-sm">Plan</dt>
                <dd className="font-medium">{formData?.plan?.name}</dd>
              </div>
              <div>
                <dt className="text-gray-500 text-sm">IMEI</dt>
                <dd className="font-medium">{formData?.imei}</dd>
              </div>
            </dl>
          </div>
          <div className="mt-5 flex w-full justify-end">
            <PrimaryButton
              title="Finalizar"
              className={
                "mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
              }
              type="button"
              onClick={() => clearProcess()}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default StatusPaymentComponent;
